import { Lock } from "lucide-react";

export const BrowserFrame = ({ src, alt, url = "fieldzai.com", className = "", eager = false }) => (
  <div
    className={`rounded-2xl border border-slate-200/80 bg-white overflow-hidden shadow-[0_25px_50px_-12px_rgba(15,23,42,0.18)] ${className}`}
  >
    <div className="flex items-center gap-3 px-4 py-2.5 bg-slate-50 border-b border-slate-200/70">
      <div className="flex items-center gap-1.5">
        <span className="w-2.5 h-2.5 rounded-full bg-[#FF5F57]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#FEBC2E]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#28C840]" />
      </div>
      <div className="flex-1 flex justify-center">
        <div className="flex items-center gap-1.5 bg-white border border-slate-200 rounded-md px-3 py-1 text-[11px] text-slate-500 font-medium max-w-[220px] w-full justify-center">
          <Lock className="w-3 h-3 text-slate-400" />
          {url}
        </div>
      </div>
      <div className="w-10" />
    </div>
    <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} width={1440} height={900} className="w-full block" />
  </div>
);

export const PhoneFrame = ({ src, alt, className = "" }) => (
  <div
    className={`rounded-[2.2rem] border-[7px] border-slate-900 bg-slate-900 overflow-hidden shadow-[0_25px_50px_-12px_rgba(15,23,42,0.35)] ${className}`}
  >
    <img src={src} alt={alt} loading="lazy" width={390} height={844} className="w-full block rounded-[1.7rem]" />
  </div>
);

export const FloatBadge = ({ icon: Icon, text, className = "", iconClassName = "text-[#0046BE]" }) => (
  <div
    className={`absolute z-10 flex items-center gap-2 bg-white/95 backdrop-blur-md border border-slate-200/80 rounded-full px-3.5 py-2 shadow-[0_12px_28px_-8px_rgba(15,23,42,0.25)] text-[12px] sm:text-[13px] font-semibold text-slate-800 whitespace-nowrap ${className}`}
  >
    <Icon className={`w-4 h-4 ${iconClassName}`} />
    {text}
  </div>
);
